const plugin = () => {
    console.log('Adoratorio Starter Kit');

    $
}

export default plugin;



/** WEBPACK FOOTER **
 ** ./components/plugins.js
 **/